var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 1.625L8.46875 2L8.84375 1.65625C9.875 0.625 11.3438 0.15625 12.75 0.40625C14.9062 0.75 16.5 2.625 16.5 4.8125V4.96875C16.5 6.28125 15.9375 7.53125 15 8.40625L9.34375 13.6875C9.125 13.9062 8.8125 14 8.5 14C8.15625 14 7.84375 13.9062 7.625 13.6875L1.96875 8.40625C1.03125 7.53125 0.5 6.28125 0.5 4.96875V4.8125C0.5 2.625 2.0625 0.75 4.21875 0.40625C5.625 0.15625 7.09375 0.625 8.125 1.625C8.125 1.65625 8.09375 1.625 8.125 1.625ZM8.46875 4.125L7.0625 2.6875C6.375 2.03125 5.40625 1.71875 4.46875 1.875C3.03125 2.125 2 3.34375 2 4.8125V4.96875C2 5.875 2.34375 6.71875 3 7.3125L8.5 12.4375L13.9688 7.3125C14.625 6.71875 15 5.875 15 4.96875V4.8125C15 3.34375 13.9375 2.125 12.5 1.875C11.5625 1.71875 10.5938 2.03125 9.90625 2.6875L8.46875 4.125Z",
    fill: "#61A60E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishList);
export default __webpack_public_path__ + "static/media/WishList.029097b97c4b43c7c0ed6fcf71050f8d.svg";
export { ForwardRef as ReactComponent };